import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { PackageDoc } from './package-doc';
export { PackageDoc };
import { packageDocSchema } from '@schemas/business-objects/package-doc';
import { NpmPackageFormGroup } from './npm-package-form-group';

export class PackageDocFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    version: SchemaFormControl;
    path: SchemaFormControl;
    title: SchemaFormControl;
    content: SchemaFormControl;
    npmPackageId: SchemaFormControl;
    npmPackage: NpmPackageFormGroup;
  };

  declare value: Partial<PackageDoc>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(packageDocSchema, PackageDoc, data, options);
  }

  get object(): PackageDoc {
    return new PackageDoc(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'npmPackage':
        return new NpmPackageFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<PackageDoc[]> {
    return PackageDoc.find(filter);
  }

  static async findOne(filter?: any): Promise<PackageDoc | null> {
    return PackageDoc.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<PackageDoc> {
    return PackageDoc.findById(id, filter);
  }

  static async create(data: Partial<PackageDoc>): Promise<PackageDoc> {
    return PackageDoc.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<PackageDoc>,
  ): Promise<PackageDoc> {
    return PackageDoc.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return PackageDoc.deleteById(id);
  }
}

export class PackageDocFormArray extends PersistedFormArray {
  declare controls: PackageDocFormGroup[];

  readonly entityName = 'PackageDoc' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(packageDocSchema, PackageDoc, options);
  }

  protected override createItemGroup() {
    return new PackageDocFormGroup();
  }

  get array(): PackageDoc[] {
    return this.controls.map((group: PackageDocFormGroup) => group.object);
  }
}

export class PackageDocPersistedArray extends PersistedArray<PackageDoc> {
  readonly entityName = 'PackageDoc' as const;

  constructor(options?: PersistedArrayOptions) {
    super(PackageDoc, options);
  }
}
